import React from 'react'
import { Body, Box, CenteredBox } from '..'
import './SelectButtons.scss'

export const SelectButtons = ({ selectedIndex, items, onClick }) => (
  <Box
    p={4}
    gap={8}
    background="white"
    className="select-buttons"
    userSelect="none"
  >
    {items.map((item, i) =>
      <CenteredBox
        key={i}
        fullHeight
        cursor={selectedIndex === i ? 'default' : 'pointer'}
        background={selectedIndex === i && 'var(--blue)'}
        color={selectedIndex === i ? 'white' : 'black'}
        onClick={() => onClick(i)}
      >
        <Body small alt bold noWrap>
          {item}
        </Body>
      </CenteredBox>
    )}
  </Box>
)
